export const PAYMENT = {
  post: "/payment",
};
